import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import Foodtab from "./Foodtab.js";
// import Foodscreens from "./Foodscreens.js";

// Add this helper function at the top (outside component)
const normalizeImageUrl = (url) => {
    if (!url || url === "N/A" || typeof url !== 'string') return null;

    // If it's already a full URL, return as is
    if (url.startsWith('http')) {
        return url;
    }

    // Remove leading slash if present and prepend base URL
    const cleanUrl = url.replace(/^\//, '');
    // Use the correct image server URL
    return `http://img.maamaas.com:8080/${cleanUrl}`;
};

const getDefaultVideoDetailsRows = () => [
    { key: "Advertisement Format", value: "", isUpload: false, isFormat: true },
    { key: "Vendor ID", value: "", isUpload: false },
    { key: "Restaurant Name", value: "", isUpload: false },
    { key: "Description", value: "", isUpload: false },
    { key: "Video Duration", value: "", isUpload: false },
    { key: "Video Time", value: "", isUpload: false },
    { key: "Start Date", value: "", isUpload: false },
    { key: "End Date", value: "", isUpload: false },
    { key: "Time Period", value: "", isUpload: false },
    { key: "Upload Date", value: "", isUpload: false },
    { key: "Screens", value: [], isUpload: false },
    { key: "Video Player", value: "", isUpload: false, isVideo: true },
    { key: "Image Content", value: "", isUpload: false, isImage: true },
    { key: "Text Content", value: "", isUpload: false, isText: true },
    { key: "Owner Name", value: "", isUpload: false },
    { key: "Company Name", value: "", isUpload: false },
    { key: "Business Type", value: "", isUpload: false },
    { key: "Company PAN", value: "", isUpload: false },
    { key: "Company PAN Document", value: "", isUpload: true },
    { key: "Company GST", value: "", isUpload: false },
    { key: "CIN", value: "", isUpload: false },
    { key: "Registered Address", value: "", isUpload: false },
    { key: "City", value: "", isUpload: false },
    { key: "State", value: "", isUpload: false },
    { key: "Pincode", value: "", isUpload: false },
    { key: "Incorporation Certificate", value: "", isUpload: true },
    { key: "GST Certificate", value: "", isUpload: true },
    { key: "Trade License", value: "", isUpload: true },
    { key: "Owner Full Name", value: "", isUpload: false },
    { key: "Owner Date of Birth", value: "", isUpload: false },
    { key: "Owner PAN", value: "", isUpload: false },
    { key: "Owner Aadhaar", value: "", isUpload: false },
    { key: "Owner Mobile", value: "", isUpload: false },
    { key: "Owner Email", value: "", isUpload: false },
    { key: "Owner Address", value: "", isUpload: false },
    { key: "Owner PAN Document", value: "", isUpload: true },
    { key: "Owner Aadhaar Document", value: "", isUpload: true },
    { key: "Owner Image", value: "", isUpload: true }
];

const STATUS_FIELD_MAP = {
    "Advertisement Format": "adFormatStatus",
    "Vendor ID": "vendorIdStatus",
    "Restaurant Name": "restaurantNameStatus",
    "Description": "descriptionStatus",
    "Video Duration": "videoDurationStatus",
    "Video Time": "videoTimeStatus",
    "Start Date": "startDateStatus",
    "End Date": "endDateStatus",
    "Time Period": "timePeriodStatus",
    "Upload Date": "uploadDateStatus",
    "Image Content": "imageContentStatus",
    "Text Content": "textContentStatus",
    "Owner Name": "ownerNameStatus",
    "Company Name": "companyNameStatus",
    "Business Type": "businessTypeStatus",
    "Company PAN": "companyPANStatus",
    "Company PAN Document": "companyPANDocumentStatus",
    "Company GST": "companyGSTStatus",
    "CIN": "cinStatus",
    "Registered Address": "registeredAddressStatus",
    "City": "cityStatus",
    "State": "stateStatus",
    "Pincode": "pincodeStatus",
    "Incorporation Certificate": "incorporationCertificateStatus",
    "GST Certificate": "gstCertificateStatus",
    "Trade License": "tradeLicenseStatus",
    "Owner Full Name": "ownerFullNameStatus",
    "Owner Date of Birth": "ownerDOBStatus",
    "Owner PAN": "ownerPANStatus",
    "Owner Aadhaar": "ownerAadhaarStatus",
    "Owner Mobile": "ownerMobileStatus",
    "Owner Email": "ownerEmailStatus",
    "Owner Address": "ownerAddressStatus",
    "Owner PAN Document": "ownerPANDocumentStatus",
    "Owner Aadhaar Document": "ownerAadhaarDocumentStatus",
    "Owner Image": "ownerImageStatus"
};

// Advertisement Format options
const adFormatOptions = [
    { value: "video", label: "Video Advertisement" },
    { value: "image", label: "Image Advertisement" },
    { value: "text", label: "Text Advertisement" },
    { value: "combined", label: "Combined (Video + Image + Text)" }
];

// Duration format options (in seconds or minutes)
const durationOptions = [
    "0:30",
    "1:00",
    "1:30",
    "2:00",
    "2:30",
    "3:00",
    "3:30",
    "4:00",
    "4:30",
    "5:00",
    "5:30",
    "6:00",
    "6:30",
    "7:00",
    "7:30",
    "8:00",
    "8:30",
    "9:00",
    "9:30",
    "10:00",
    "15:00",
    "20:00",
    "30:00",
    "45:00",
    "60:00"
];

// Time options (for video time - when video was recorded/posted)
const timeOptions = [
    "Morning (6AM - 12PM)",
    "Afternoon (12PM - 4PM)",
    "Evening (4PM - 7PM)",
    "Night (7PM - 10PM)",
    "Late Night (10PM - 6AM)"
];

// Green theme colors
const GREEN_COLORS = {
    primary: '#4CAF50',      // Main green
    light: '#E8F5E9',        // Light green for hover
    dark: '#2E7D32',         // Dark green for text
    background: '#F1F8E9',   // Very light green for backgrounds
    shadow: 'rgba(76, 175, 80, 0.3)' // Green shadow
};

// Safe date conversion utility
const safeDateToISOString = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    return date.toISOString().split("T")[0];
};

// Safe date display utility
const safeDateDisplay = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

// Calculate time period between two dates
const calculateTimePeriod = (startDate, endDate) => {
    if (!startDate || !endDate || startDate === "N/A" || endDate === "N/A") return "N/A";

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) return "N/A";

    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 30) {
        return `${diffDays} days`;
    } else if (diffDays < 365) {
        const months = Math.floor(diffDays / 30);
        const remainingDays = diffDays % 30;
        return remainingDays > 0 ? `${months} months, ${remainingDays} days` : `${months} months`;
    } else {
        const years = Math.floor(diffDays / 365);
        const remainingDays = diffDays % 365;
        const months = Math.floor(remainingDays / 30);
        const days = remainingDays % 30;

        if (months > 0 && days > 0) {
            return `${years} years, ${months} months, ${days} days`;
        } else if (months > 0) {
            return `${years} years, ${months} months`;
        } else if (days > 0) {
            return `${years} years, ${days} days`;
        } else {
            return `${years} years`;
        }
    }
};

// Format duration from seconds to MM:SS format
const formatDuration = (seconds) => {
    if (!seconds || seconds === "N/A") return "N/A";

    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};

// Parse duration from MM:SS to seconds
const parseDuration = (durationStr) => {
    if (!durationStr || durationStr === "N/A") return 0;

    const parts = durationStr.split(':');
    if (parts.length === 2) {
        const mins = parseInt(parts[0], 10);
        const secs = parseInt(parts[1], 10);
        return (mins * 60) + secs;
    }
    return 0;
};

// Updated hasValidData function
const hasValidData = (row, videoDetails) => {
    if (!row) return false;

    const field = row.key;
    const value = row.value;

    // Special case for empty arrays
    if (Array.isArray(value)) {
        return value.length > 0 && value[0] !== "N/A";
    }

    // Check if the value exists and is not empty/"N/A"
    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        // For address or other objects
        return Object.values(value).some(val =>
            val && val !== "N/A" && val.toString().trim() !== ""
        );
    }

    // For numbers
    if (typeof value === 'number') {
        return value !== undefined && value !== null;
    }

    // For fields that are just text labels
    if (value === "Company PAN Document" || value === "GST Certificate" ||
        value === "Trade License" || value === "Incorporation Certificate" ||
        value === "Owner PAN Document" || value === "Owner Aadhaar Document" ||
        value === "Owner Image") {
        // Check if there are images for these fields
        const hasImages = row.images && row.images.length > 0;
        return hasImages;
    }

    return false;
};

// Updated isFieldVerified function
const isFieldVerified = (rowKey, rowValue, videoDetails, rowImages) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    // If there's a status field in the backend, check its value
    if (statusField && videoDetails && videoDetails[statusField] !== undefined) {
        return videoDetails[statusField] === true;
    }

    // Create a row object to pass to hasValidData
    const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

    // Always auto-verify these specific fields if they have data
    const alwaysAutoVerifyFields = [
        "Advertisement Format",
        "Vendor ID",
        "Restaurant Name",
        "Description",
        "Video Duration",
        "Video Time",
        "Start Date",
        "End Date",
        "Time Period",
        "Upload Date",
        "Image Content",
        "Text Content",
        "Owner Name",
        "Company Name",
        "Business Type",
        "Company PAN",
        "Company GST",
        "CIN",
        "Registered Address",
        "City",
        "State",
        "Pincode",
        "Owner Full Name",
        "Owner Date of Birth",
        "Owner PAN",
        "Owner Aadhaar",
        "Owner Mobile",
        "Owner Email",
        "Owner Address"
    ];

    if (alwaysAutoVerifyFields.includes(rowKey)) {
        return hasValidData(rowForValidation, videoDetails);
    }

    // For document/image fields, check both data and images
    const documentFields = [
        "Company PAN Document",
        "Incorporation Certificate",
        "GST Certificate",
        "Trade License",
        "Owner PAN Document",
        "Owner Aadhaar Document",
        "Owner Image"
    ];

    if (documentFields.includes(rowKey)) {
        // For document fields, require images
        const hasImages = rowImages && rowImages.length > 0;
        return hasImages;
    }

    return false;
};

const isFieldRejected = (rowKey, videoDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (!statusField || !videoDetails) return false;

    return videoDetails[statusField] === false;
};

// New function to check if a field can be verified
const canVerifyField = (rowKey, rowValue, videoDetails, rowImages) => {
    // Check if there's valid data
    return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, videoDetails);
};

/* ---------------- component ---------------- */
const FoodVideosSuperadmin = () => {
    /* -------- list‑screen state -------- */
    const [videosData, setVideosData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { showLoader, hideLoader } = useLoader();

    // Filter states
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    // State for playing video in table
    const [playingVideoId, setPlayingVideoId] = useState(null);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [selectedVideoForPlay, setSelectedVideoForPlay] = useState(null);

    // State for screen management modal
    const [showScreenModal, setShowScreenModal] = useState(false);
    const [addedScreens, setAddedScreens] = useState([]);

    /* -------- detail‑screen state -------- */
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoDetails, setVideoDetails] = useState(null);
    const [videoNotFound, setVideoNotFound] = useState(false);
    const [videoError, setVideoError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedScreen, setSelectedScreen] = useState(null);
    const [selectedAdFormat, setSelectedAdFormat] = useState("video");
    const [activeContentType, setActiveContentType] = useState('video'); // For combined format

    // Global approval/rejection states
    const [isApproving, setIsApproving] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);
    const [showRejectDropdown, setShowRejectDropdown] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");

    const [rows, setRows] = useState(getDefaultVideoDetailsRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);

    // Mock data for demonstration with Vendor ID, Restaurant Name, and Screens
    const mockFoodVideos = [
        {
            id: 1,
            vendorId: "VND-001",
            restaurantName: "Pizza Paradise",
            adFormat: "video",
            description: "Learn how to make authentic Italian pizza at home with this step-by-step tutorial",
            screens: ["Screen 1", "Screen 3", "Screen 5"],
            videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
            imageContent: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
            textContent: "Special offer: Buy 1 Get 1 Free on all pizzas this weekend!",
            thumbnail: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
            duration: "4:30",
            videoDuration: 270, // in seconds
            videoTime: "Evening (4PM - 7PM)",
            startDate: "2024-01-01",
            endDate: "2024-12-31",
            timePeriod: "1 year",
            uploadDate: "2024-01-15",
            verificationStatus: "verified",
            companyDetails: {
                companyName: "Pizza Paradise Inc",
                businessType: "Proprietorship",
                companyPAN: "123456",
                companyPANDocument: "Company PAN Document-0",
                companyGST: "12345623442",
                cin: "852669545",
                registeredAddress: "kphb",
                city: "hydss",
                state: "telanganaa",
                pincode: "505103",
                incorporationCertificate: "Incorporation Certificate-0",
                gstCertificate: "GST Certificate-0",
                tradeLicense: "Trade License-0",
                ownerFullName: "vasu",
                ownerDOB: "2025-12-26",
                ownerPAN: "8547563",
                ownerAadhaar: "2547895",
                ownerMobile: "94924947782",
                ownerEmail: "vassu@gmail.com",
                ownerAddress: "hyds",
                ownerPANDocument: "Owner PAN Document-0",
                ownerAadhaarDocument: "Owner Aadhaar Document-0",
                ownerImage: "Owner Image-0"
            }
        },
        {
            id: 2,
            vendorId: "VND-002",
            restaurantName: "Biryani House",
            adFormat: "image",
            description: "Traditional Hyderabadi biryani recipe with secret spices",
            screens: ["Screen 2", "Screen 4"],
            videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
            imageContent: "https://images.unsplash.com/photo-1563379091339-03246963eec1?w=400",
            textContent: "Weekend special: 20% off on all biryani orders!",
            thumbnail: "https://images.unsplash.com/photo-1563379091339-03246963eec1?w=400",
            duration: "8:45",
            videoDuration: 525, // in seconds
            videoTime: "Afternoon (12PM - 4PM)",
            startDate: "2024-02-01",
            endDate: "2024-11-30",
            timePeriod: "10 months",
            uploadDate: "2024-01-10",
            verificationStatus: "pending",
            companyDetails: {
                companyName: "Biryani House",
                businessType: "Partnership",
                companyPAN: "789012",
                companyPANDocument: "Company PAN Document-1",
                companyGST: "78901234567",
                cin: "123456789",
                registeredAddress: "hitech city",
                city: "hyderabad",
                state: "telangana",
                pincode: "500081",
                incorporationCertificate: "Incorporation Certificate-1",
                gstCertificate: "GST Certificate-1",
                tradeLicense: "Trade License-1",
                ownerFullName: "rahul",
                ownerDOB: "1990-01-15",
                ownerPAN: "9876543",
                ownerAadhaar: "1234567",
                ownerMobile: "9876543210",
                ownerEmail: "rahul@gmail.com",
                ownerAddress: "hitech city",
                ownerPANDocument: "Owner PAN Document-1",
                ownerAadhaarDocument: "Owner Aadhaar Document-1",
                ownerImage: "Owner Image-1"
            }
        },
        {
            id: 3,
            vendorId: "VND-003",
            restaurantName: "Cake Studio",
            adFormat: "text",
            description: "Moist and rich chocolate cake recipe for beginners",
            screens: ["Screen 1", "Screen 2", "Screen 6"],
            videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
            imageContent: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400",
            textContent: "New dessert menu launched! Try our signature chocolate cake.",
            thumbnail: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400",
            duration: "6:15",
            videoDuration: 375, // in seconds
            videoTime: "Morning (6AM - 12PM)",
            startDate: "2024-03-01",
            endDate: "2024-09-30",
            timePeriod: "7 months",
            uploadDate: "2024-01-05",
            verificationStatus: "rejected",
            companyDetails: {
                companyName: "Cake Studio",
                businessType: "LLC",
                companyPAN: "456789",
                companyPANDocument: "Company PAN Document-2",
                companyGST: "45678901234",
                cin: "987654321",
                registeredAddress: "jubilee hills",
                city: "hyderabad",
                state: "telangana",
                pincode: "500033",
                incorporationCertificate: "Incorporation Certificate-2",
                gstCertificate: "GST Certificate-2",
                tradeLicense: "Trade License-2",
                ownerFullName: "priya",
                ownerDOB: "1985-05-20",
                ownerPAN: "4567890",
                ownerAadhaar: "7890123",
                ownerMobile: "9988776655",
                ownerEmail: "priya@gmail.com",
                ownerAddress: "jubilee hills",
                ownerPANDocument: "Owner PAN Document-2",
                ownerAadhaarDocument: "Owner Aadhaar Document-2",
                ownerImage: "Owner Image-2"
            }
        },
        {
            id: 4,
            vendorId: "VND-004",
            restaurantName: "Cool Drinks",
            adFormat: "combined",
            description: "Refreshing summer beverage recipes",
            screens: ["Screen 1", "Screen 3", "Screen 5", "Screen 7"],
            videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
            imageContent: "https://images.unsplash.com/photo-1551024601-bec78ae704b2?w=400",
            textContent: "Buy 2 Get 1 Free on all summer coolers!",
            thumbnail: "https://images.unsplash.com/photo-1551024601-bec78ae704b2?w=400",
            duration: "5:30",
            videoDuration: 330,
            videoTime: "Afternoon (12PM - 4PM)",
            startDate: "2024-04-01",
            endDate: "2024-08-31",
            timePeriod: "5 months",
            uploadDate: "2024-03-15",
            verificationStatus: "pending",
            companyDetails: {
                companyName: "Cool Drinks",
                businessType: "Proprietorship",
                companyPAN: "789123",
                companyPANDocument: "Company PAN Document-3",
                companyGST: "78912345678",
                cin: "456789123",
                registeredAddress: "banjara hills",
                city: "hyderabad",
                state: "telangana",
                pincode: "500034",
                incorporationCertificate: "Incorporation Certificate-3",
                gstCertificate: "GST Certificate-3",
                tradeLicense: "Trade License-3",
                ownerFullName: "suresh",
                ownerDOB: "1988-08-15",
                ownerPAN: "7891234",
                ownerAadhaar: "4567890",
                ownerMobile: "8877665544",
                ownerEmail: "suresh@gmail.com",
                ownerAddress: "banjara hills",
                ownerPANDocument: "Owner PAN Document-3",
                ownerAadhaarDocument: "Owner Aadhaar Document-3",
                ownerImage: "Owner Image-3"
            }
        }
    ];

    // Screen resize effect
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getCurrentVideoId = () => {
        return selectedVideo?.id || null;
    };

    const videoId = getCurrentVideoId();

    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    const fetchVideoDetails = async (videoId) => {
        if (!videoId) return;
        setLoading(true);
        setVideoNotFound(false);
        setVideoError(null);

        // For demo, find video in mock data
        try {
            const video = mockFoodVideos.find(v => v.id === videoId);

            if (!video) {
                setVideoNotFound(true);
                setVideoDetails(null);
                setVideoError("Video not found");
                setLoading(false);
                return;
            }

            setVideoDetails(video);
            setSelectedAdFormat(video.adFormat || "video");
            setActiveContentType(video.adFormat === "combined" ? "video" : video.adFormat);
            setVideoNotFound(false);
            setVideoError(null);

        } catch (err) {
            console.error("❌ get-video-details error:", err);
            setVideoNotFound(true);
            setVideoDetails(null);
            setVideoError("Video not found");
        } finally {
            setLoading(false);
        }
    };

    const handleSaveRow = async (rowIndex) => {
        // For demo, just update local state
        try {
            const videoId = selectedVideo?.id;
            if (!videoId) {
                console.error("Video ID not found");
                return;
            }

            const row = rows[rowIndex];

            alert("Data updated successfully!");

            setRows(prev =>
                prev.map((r, idx) => (idx === rowIndex ? { ...r, isEditing: false } : r))
            );

            fetchVideoDetails(videoId);

        } catch (err) {
            console.error("Error updating video:", err);
            alert("Error updating data: " + err.message);
        }
    };

    const getImageFieldName = (rowKey, imageIndex) => {
        const fieldMap = {
            "Company PAN Document": "companyPANDocument",
            "Incorporation Certificate": "incorporationCertificate",
            "GST Certificate": "gstCertificate",
            "Trade License": "tradeLicense",
            "Owner PAN Document": "ownerPANDocument",
            "Owner Aadhaar Document": "ownerAadhaarDocument",
            "Owner Image": "ownerImage",
            "Image Content": "imageContent"
        };

        return fieldMap[rowKey] || `image${imageIndex + 1}`;
    };

    const handleVerify = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const videoId = getCurrentVideoId();
        if (!videoId) return alert("Video ID is missing");

        if (videoNotFound) {
            alert("Video not found. Cannot verify.");
            return;
        }

        try {
            // Update local state immediately for better UX
            setVideoDetails(prev => ({
                ...prev,
                [statusField]: true
            }));

            // For demo, update the mock data
            setVideosData(prev => prev.map(v =>
                v.id === videoId
                    ? { ...v, [statusField]: true }
                    : v
            ));

            alert("Video data verified successfully!");

            // Refresh video details
            await fetchVideoDetails(videoId);
        } catch (err) {
            console.error("❌ Verify error:", err);
            alert(`Failed to update status: ${err.message}`);
        }
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const videoId = getCurrentVideoId();
        if (!videoId) return alert("Video ID is missing");

        if (videoNotFound) {
            alert("Video not found. Cannot reject.");
            return;
        }

        try {
            // Update local state immediately
            setVideoDetails(prev => ({
                ...prev,
                [statusField]: false
            }));

            // For demo, update the mock data
            setVideosData(prev => prev.map(v =>
                v.id === videoId
                    ? { ...v, [statusField]: false }
                    : v
            ));

            alert("Video status rejected successfully!");

            // Refresh video details
            await fetchVideoDetails(videoId);
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject status: ${err.message}`);
        }
    };

    // Global approve function
    const handleGlobalApprove = async () => {
        setIsApproving(true);

        // Simulate API call
        setTimeout(() => {
            // Update all fields to verified
            const updatedStatuses = {};
            Object.keys(STATUS_FIELD_MAP).forEach(key => {
                const statusField = STATUS_FIELD_MAP[key];
                if (statusField) {
                    updatedStatuses[statusField] = true;
                }
            });

            setVideoDetails(prev => ({
                ...prev,
                ...updatedStatuses
            }));

            alert("Video approved successfully!");
            setIsApproving(false);
        }, 1000);
    };

    // Global reject function
    const handleGlobalReject = async () => {
        if (!rejectionReason.trim()) {
            alert("Please enter a rejection reason");
            return;
        }

        setIsRejecting(true);

        // Simulate API call
        setTimeout(() => {
            // Update all fields to rejected
            const updatedStatuses = {};
            Object.keys(STATUS_FIELD_MAP).forEach(key => {
                const statusField = STATUS_FIELD_MAP[key];
                if (statusField) {
                    updatedStatuses[statusField] = false;
                }
            });

            setVideoDetails(prev => ({
                ...prev,
                ...updatedStatuses
            }));

            alert(`Video rejected successfully! Reason: ${rejectionReason}`);
            setShowRejectDropdown(false);
            setRejectionReason("");
            setIsRejecting(false);
        }, 1000);
    };

    // Handle play video from table
    const handlePlayVideo = (video, e) => {
        e.stopPropagation();
        if (video.adFormat === 'video' || video.adFormat === 'combined') {
            setSelectedVideoForPlay(video);
            setShowVideoModal(true);
        }
    };

    // Close video modal
    const closeVideoModal = () => {
        setShowVideoModal(false);
        setSelectedVideoForPlay(null);
    };

    // Handle save screens from modal
    const handleSaveScreens = (screenData) => {

        // Add the new screens to your existing screens list
        const newScreens = screenData.screens.map(screen => ({
            name: screen,
            category: screenData.category,
            subCategory: screenData.subCategory
        }));

        setAddedScreens(prev => [...prev, ...newScreens]);

        // Show success message
        alert(`✅ ${screenData.screens.length} screens added successfully!\nCategory: ${screenData.category}\nScreens: ${screenData.screens.join(', ')}`);

        setShowScreenModal(false);
    };

    // Fetch videos data
    useEffect(() => {
        showLoader();

        // Simulate API call with mock data
        setTimeout(() => {
            setVideosData(mockFoodVideos);
            setFilteredData(mockFoodVideos);
            hideLoader();
        }, 1000);
    }, []);

    // Apply filters
    useEffect(() => {
        let result = videosData;

        // Apply status filter
        if (statusFilter) {
            result = result.filter(item => item.verificationStatus === statusFilter);
        }

        // Apply search query
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                let fieldValue;

                if (searchType === "vendorId") {
                    fieldValue = item.vendorId;
                } else if (searchType === "restaurantName") {
                    fieldValue = item.restaurantName;
                } else if (searchType === "status") {
                    fieldValue = item.verificationStatus;
                } else if (searchType === "adFormat") {
                    fieldValue = item.adFormat;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        setFilteredData(result);
    }, [videosData, statusFilter, searchType, searchQuery]);

    // Clear all filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setStatusFilter("");
        setSearchType("vendorId");
    };

    // Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "restaurantName": return "Search by Restaurant Name...";
            case "status": return "Search by status...";
            case "adFormat": return "Search by ad format...";
            default: return "Search...";
        }
    };

    // Search options
    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "restaurantName", label: "Restaurant Name" },
        { value: "status", label: "Status" },
        { value: "adFormat", label: "Ad Format" }
    ];

    // Status options for filter
    const statusOptions = [
        { value: "verified", label: "Verified" },
        { value: "pending", label: "Pending" },
        { value: "rejected", label: "Rejected" }
    ];

    useEffect(() => {
        if (!selectedVideo) {
            setRows(getDefaultVideoDetailsRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            setSelectedScreen(null);
            return;
        }

        const merged = { ...selectedVideo, ...(videoDetails || {}), ...(videoDetails?.companyDetails || {}) };

        // Calculate time period from start and end dates
        const calculatedTimePeriod = calculateTimePeriod(merged.startDate, merged.endDate);

        // Image mapping using normalizeImageUrl
        const imageMap = {
            "Company PAN Document": [normalizeImageUrl(merged.companyPANDocument)].filter(url => url),
            "Incorporation Certificate": [normalizeImageUrl(merged.incorporationCertificate)].filter(url => url),
            "GST Certificate": [normalizeImageUrl(merged.gstCertificate)].filter(url => url),
            "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
            "Owner PAN Document": [normalizeImageUrl(merged.ownerPANDocument)].filter(url => url),
            "Owner Aadhaar Document": [normalizeImageUrl(merged.ownerAadhaarDocument)].filter(url => url),
            "Owner Image": [normalizeImageUrl(merged.ownerImage)].filter(url => url),
            "Image Content": [normalizeImageUrl(merged.imageContent)].filter(url => url),
        };

        const newRows = [
            // Advertisement Format
            { key: "Advertisement Format", value: merged.adFormat || "video" },

            // Video Information with Vendor ID, Restaurant Name, and Screens
            { key: "Vendor ID", value: merged.vendorId || `VND-${String(merged.id).padStart(3, '0')}` },
            { key: "Restaurant Name", value: merged.restaurantName || merged.companyDetails?.companyName || "N/A" },
            { key: "Description", value: merged.description || "N/A" },
            { key: "Video Duration", value: merged.duration || formatDuration(merged.videoDuration) || "N/A" },
            { key: "Video Time", value: merged.videoTime || "N/A" },
            { key: "Start Date", value: merged.startDate || "N/A" },
            { key: "End Date", value: merged.endDate || "N/A" },
            { key: "Time Period", value: calculatedTimePeriod || merged.timePeriod || "N/A" },
            { key: "Upload Date", value: merged.uploadDate || "N/A" },
            { key: "Screens", value: merged.screens || [] },
            { key: "Video Player", value: merged.videoUrl || "N/A", isVideo: true },
            { key: "Image Content", value: merged.imageContent || "N/A", isImage: true },
            { key: "Text Content", value: merged.textContent || "N/A", isText: true },

            // Company Details
            { key: "Owner Name", value: merged.ownerFullName || "N/A" },
            { key: "Company Name", value: merged.companyName || "N/A" },
            { key: "Business Type", value: merged.businessType || "N/A" },
            { key: "Company PAN", value: merged.companyPAN || "N/A" },
            { key: "Company PAN Document", value: "Company PAN Document" },
            { key: "Company GST", value: merged.companyGST || "N/A" },
            { key: "CIN", value: merged.cin || "N/A" },
            { key: "Registered Address", value: merged.registeredAddress || "N/A" },
            { key: "City", value: merged.city || "N/A" },
            { key: "State", value: merged.state || "N/A" },
            { key: "Pincode", value: merged.pincode || "N/A" },
            { key: "Incorporation Certificate", value: "Incorporation Certificate" },
            { key: "GST Certificate", value: "GST Certificate" },
            { key: "Trade License", value: "Trade License" },

            // Owner Details
            { key: "Owner Full Name", value: merged.ownerFullName || "N/A" },
            { key: "Owner Date of Birth", value: merged.ownerDOB || "N/A" },
            { key: "Owner PAN", value: merged.ownerPAN || "N/A" },
            { key: "Owner Aadhaar", value: merged.ownerAadhaar || "N/A" },
            { key: "Owner Mobile", value: merged.ownerMobile || "N/A" },
            { key: "Owner Email", value: merged.ownerEmail || "N/A" },
            { key: "Owner Address", value: merged.ownerAddress || "N/A" },
            { key: "Owner PAN Document", value: "Owner PAN Document" },
            { key: "Owner Aadhaar Document", value: "Owner Aadhaar Document" },
            { key: "Owner Image", value: "Owner Image" },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setIsApproved(false);
        setImageLoadErrors(new Set());
        setSelectedScreen(null);
    }, [selectedVideo, videoDetails]);

    const handleViewClick = (video) => {
        setSelectedVideo(video);
        const videoId = video?.id;
        setVideoNotFound(false);
        setVideoError(null);
        fetchVideoDetails(videoId);
        // Automatically select the first screen if available
        if (video.screens && video.screens.length > 0) {
            setSelectedScreen(video.screens[0]);
        }
    };

    const handleBackClick = () => {
        setSelectedVideo(null);
        setVideoNotFound(false);
        setVideoError(null);
        setSelectedScreen(null);
        setShowRejectDropdown(false);
        setRejectionReason("");
    };

    const handleFileChange = (e, index) => {
        const fileName = e.target.files[0]?.name || "";
        const updated = [...rows];
        updated[index].value = fileName;
        setRows(updated);
    };

    const handleScreenSelect = (screen) => {
        setSelectedScreen(screen);
    };

    const handleAdFormatChange = (format) => {
        setSelectedAdFormat(format);
        setActiveContentType(format === "combined" ? "video" : format);
        // Update the row value for Advertisement Format
        setRows(prev => prev.map(row =>
            row.key === "Advertisement Format"
                ? { ...row, value: format }
                : row
        ));
        // Reset selected screen when format changes
        setSelectedScreen(null);
    };

    // Check if field should be visible based on selected ad format
    const shouldShowField = (rowKey) => {
        // Always show basic info fields
        const basicFields = [
            "Advertisement Format",
            "Vendor ID",
            "Restaurant Name",
            "Description",
            "Video Duration",
            "Video Time",
            "Start Date",
            "End Date",
            "Time Period",
            "Upload Date",
            "Screens"
        ];

        if (basicFields.includes(rowKey)) {
            return true;
        }

        // Always show Video Player regardless of format
        if (rowKey === "Video Player") {
            return true;
        }

        // Show/hide based on selected ad format
        switch (selectedAdFormat) {
            case "video":
                // For video format, show video player and all company/owner fields
                return rowKey === "Video Player" ||
                    rowKey === "Image Content" ||
                    rowKey.startsWith("Company") ||
                    rowKey.startsWith("Owner");

            case "image":
                // For image format, show image content and all company/owner fields
                return rowKey === "Image Content" ||
                    rowKey.startsWith("Company") ||
                    rowKey.startsWith("Owner");

            case "text":
                // For text format, show text content and all company/owner fields
                return rowKey === "Text Content" ||
                    rowKey.startsWith("Company") ||
                    rowKey.startsWith("Owner");

            case "combined":
                // Show all content types
                return rowKey === "Video Player" ||
                    rowKey === "Image Content" ||
                    rowKey === "Text Content" ||
                    rowKey.startsWith("Company") ||
                    rowKey.startsWith("Owner");

            default:
                return true;
        }
    };

    // Clean Image Display Component with "-" for missing images
    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: fieldName === "Owner Image" || fieldName === "Image Content" ? "80px" : "60px",
                                    height: fieldName === "Owner Image" || fieldName === "Image Content" ? "80px" : "60px",
                                    borderRadius: "6px",
                                    objectFit: "cover",
                                    border: "1px solid #dee2e6",
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    // Video Modal Component
    const VideoModal = ({ video, onClose }) => {
        if (!video) return null;

        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }} onClick={onClose}>
                <div style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '12px',
                    width: '800px',
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    position: 'relative'
                }} onClick={(e) => e.stopPropagation()}>
                    <button
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '15px',
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#666',
                            zIndex: 1
                        }}
                    >
                        ×
                    </button>

                    <h3 style={{ marginBottom: '15px', color: '#333', paddingRight: '30px' }}>
                        {video.restaurantName} - {video.vendorId}
                    </h3>

                    <video
                        width="100%"
                        controls
                        autoPlay
                        style={{ maxHeight: '60vh', borderRadius: '8px' }}
                    >
                        <source src={video.videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <div style={{
                        marginTop: '15px',
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px'
                    }}>
                        <p><strong>Duration:</strong> {video.duration}</p>
                        <p><strong>Description:</strong> {video.description}</p>
                        <p><strong>Screens:</strong> {video.screens?.join(', ')}</p>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="container-fluid">
            {/* Video Modal */}
            {showVideoModal && (
                <VideoModal video={selectedVideoForPlay} onClose={closeVideoModal} />
            )}

            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "10px" }}>
                    <div className="client" style={{ overflowY: "auto", height: "450px" }}>
                        {!selectedVideo ? (
                            <>
                                {/* Filter Controls */}
                                <div className="row g-2 mb-3 align-items-center me-0">
                                    {/* Search Type Dropdown and Search Input */}
                                    <div className="col-md-auto col-12">
                                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                            {/* Search Type Dropdown */}
                                            <div style={{ minWidth: '150px' }}>
                                                <select
                                                    className="form-select"
                                                    value={searchType}
                                                    onChange={(e) => setSearchType(e.target.value)}
                                                    style={{ height: "40px" }}
                                                >
                                                    {searchOptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Search Input */}
                                            <div style={{ minWidth: '200px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={getPlaceholderText()}
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ height: "40px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Status Filter */}
                                    <div className="col-md-auto col-12">
                                        <select
                                            className="form-select"
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                            aria-label="Filter by status"
                                            style={{ maxWidth: '200px', height: "40px" }}
                                        >
                                            <option value="">All Statuses</option>
                                            {statusOptions.map(option => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Clear Filters Button */}
                                    <div className="col-md-auto col-12">
                                        <button
                                            className="btn"
                                            onClick={clearAllFilters}
                                            style={{
                                                backgroundColor: '#6c757d',
                                                color: '#fff',
                                                height: "40px",
                                                padding: "0 15px"
                                            }}
                                        >
                                            Clear Filters
                                        </button>
                                    </div>
                                </div>

                                {/* Videos Table */}
                                <div className="sed pe-3">
                                    <table style={tableStyle} className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={thStyle}>S.NO</th>
                                                <th style={thStyle}>Vendor ID</th>
                                                <th style={thStyle}>Restaurant Name</th>
                                                <th style={thStyle}>Screens</th>
                                                <th style={thStyle}>Ad Format</th>
                                                <th style={thStyle}>Duration</th>
                                                <th style={thStyle}>Start Date</th>
                                                <th style={thStyle}>End Date</th>
                                                <th style={thStyle}>Time Period</th>
                                                <th style={thStyle}>Upload Date</th>
                                                <th style={thStyle}>Status</th>
                                                <th style={thStyle}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length ? (
                                                filteredData.map((video, idx) => (
                                                    <tr key={video.id || idx}>
                                                        <td style={thTdStyle}>{idx + 1}</td>
                                                        <td style={thTdStyle}>{video.vendorId || `VND-${String(idx + 1).padStart(3, '0')}`}</td>
                                                        <td style={thTdStyle}>{video.restaurantName || video.companyDetails?.companyName || "—"}</td>
                                                        <td style={thTdStyle}>
                                                            {video.screens && video.screens.length > 0 ? (
                                                                <div className="d-flex flex-wrap gap-1 justify-content-center">
                                                                    {video.screens.map((screen, i) => (
                                                                        <span key={i} style={{
                                                                            backgroundColor: '#E8F5E9',  // Light green background
                                                                            color: '#4CAF50',             // Green text
                                                                            padding: '2px 8px',
                                                                            borderRadius: '4px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '500',
                                                                            border: '1px solid #4CAF50',
                                                                            margin: '2px'
                                                                        }}>
                                                                            {screen}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            ) : "—"}
                                                        </td>
                                                        <td style={thTdStyle}>
                                                            <div style={{ position: 'relative' }}>
                                                                <span
                                                                    style={{
                                                                        ...getAdFormatBadge(video.adFormat),
                                                                        cursor: video.adFormat === 'video' || video.adFormat === 'combined' ? 'pointer' : 'default',
                                                                        paddingRight: video.adFormat === 'video' || video.adFormat === 'combined' ? '30px' : '8px',
                                                                        position: 'relative'
                                                                    }}
                                                                    onClick={(e) => handlePlayVideo(video, e)}
                                                                    title={video.adFormat === 'video' || video.adFormat === 'combined' ? 'Click to play video' : ''}
                                                                >
                                                                    {video.adFormat || "—"}
                                                                    {(video.adFormat === 'video' || video.adFormat === 'combined') && (
                                                                        <span style={{
                                                                            position: 'absolute',
                                                                            right: '8px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            fontSize: '14px',
                                                                            filter: 'brightness(0) invert(1)'
                                                                        }}>
                                                                            ▶️
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td style={thTdStyle}>{video.duration || "—"}</td>
                                                        <td style={thTdStyle}>{safeDateDisplay(video.startDate)}</td>
                                                        <td style={thTdStyle}>{safeDateDisplay(video.endDate)}</td>
                                                        <td style={thTdStyle}>{video.timePeriod || calculateTimePeriod(video.startDate, video.endDate)}</td>
                                                        <td style={thTdStyle}>{safeDateDisplay(video.uploadDate)}</td>
                                                        <td style={thTdStyle}>
                                                            <span style={getStatusBadge(video.verificationStatus)}>
                                                                {video.verificationStatus?.charAt(0).toUpperCase() + video.verificationStatus?.slice(1) || "Pending"}
                                                            </span>
                                                        </td>
                                                        <td style={thTdStyle}>
                                                            <button
                                                                style={{ ...buttonStyle, color: "#b15cd6", fontWeight: "bold" }}
                                                                onClick={() => handleViewClick(video)}
                                                            >
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td style={thTdStyle} colSpan={12}>
                                                        {videosData.length === 0
                                                            ? "Loading data or no videos found."
                                                            : (searchQuery.trim() || statusFilter)
                                                                ? "No data found with the specified filters."
                                                                : "No data available."}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <div className="mt-4 rounded-3 shadow-sm">
                                <div className="d-flex align-items-center mb-4">
                                    <button
                                        onClick={handleBackClick}
                                        className="btn fw-bold px-4 py-2"
                                        style={{ backgroundColor: "#b15cd6", color: "#fff" }}
                                    >
                                        Back to List
                                    </button>
                                </div>

                                {loading && (
                                    <div className="text-center my-4">
                                        <span className="spinner-border text-primary" />
                                    </div>
                                )}

                                {!loading && videoNotFound && (
                                    <div className="text-center my-5 py-5">
                                        <div style={{ fontSize: "24px", color: "#dc3545", marginBottom: "16px" }}>
                                            ⚠️ Video Not Found
                                        </div>
                                        <p style={{ fontSize: "16px", color: "#6c757d" }}>
                                            This video could not be found in the system.
                                            <br />
                                            Video ID: {selectedVideo?.id}
                                        </p>
                                    </div>
                                )}

                                {!loading && !videoNotFound && videoDetails && (
                                    <div className="register mt-4">
                                        <div className="registertable bo2">
                                            <table className="table table-bordered table-striped align-middle mt-4 w-100">
                                                <thead>
                                                    <tr>
                                                        <th style={detailThStyle}>Field</th>
                                                        <th style={detailThStyle}>Value</th>
                                                        <th style={detailThStyle}>Image</th>
                                                        <th style={detailThStyle}>Status</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {rows.map((r, i) => {
                                                        // Skip fields that shouldn't be shown based on ad format
                                                        if (!shouldShowField(r.key)) {
                                                            return null;
                                                        }

                                                        const isEditing = r.isEditing || false;
                                                        const isVideoPlayer = r.key === "Video Player";
                                                        const isScreens = r.key === "Screens";
                                                        const isImageContent = r.key === "Image Content";
                                                        const isTextContent = r.key === "Text Content";
                                                        const isAdFormat = r.key === "Advertisement Format";

                                                        const handleInputChange = (field, value) => {
                                                            setRows((prevRows) =>
                                                                prevRows.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            value:
                                                                                typeof row.value === "object"
                                                                                    ? { ...row.value, [field]: value }
                                                                                    : value,
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        // Handle Ad Format selection
                                                        const handleAdFormatSelect = (selectedValue) => {
                                                            handleAdFormatChange(selectedValue);
                                                            handleInputChange("value", selectedValue);
                                                        };

                                                        // Handle Video Duration selection
                                                        const handleDurationChange = (selectedValue) => {
                                                            setRows((prevRows) =>
                                                                prevRows.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            value: selectedValue,
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        // Handle Video Time selection
                                                        const handleVideoTimeChange = (selectedValue) => {
                                                            setRows((prevRows) =>
                                                                prevRows.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            value: selectedValue,
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        const handleImageChange = (e) => {
                                                            const files = Array.from(e.target.files);
                                                            const newImages = files.map((file) => ({
                                                                url: URL.createObjectURL(file),
                                                                file
                                                            }));

                                                            setRows(prev =>
                                                                prev.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            images: [...(row.images || []), ...newImages]
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        // Check if field is editable (non-readonly fields)
                                                        const isEditableField = ![
                                                            "Time Period",
                                                            "Screens",
                                                            "Video Player",
                                                            "City",
                                                            "State",
                                                            "Pincode"
                                                        ].includes(r.key);

                                                        return (
                                                            <tr key={r.key || i}>
                                                                <td className="fw-bold text-center align-middle">{r.key}</td>

                                                                <td className="text-start align-middle">
                                                                    {isScreens ? (
                                                                        <div className="d-flex flex-wrap gap-2">
                                                                            {Array.isArray(r.value) && r.value.map((screen, index) => (
                                                                                <button
                                                                                    key={index}
                                                                                    className="btn"
                                                                                    onClick={() => handleScreenSelect(screen)}
                                                                                    style={{
                                                                                        padding: '6px 12px',
                                                                                        fontSize: '12px',
                                                                                        fontWeight: '500',
                                                                                        borderRadius: '6px',
                                                                                        cursor: 'pointer',
                                                                                        transition: 'all 0.3s ease',
                                                                                        backgroundColor: selectedScreen === screen ? GREEN_COLORS.primary : 'transparent',
                                                                                        color: selectedScreen === screen ? 'white' : GREEN_COLORS.primary,
                                                                                        border: selectedScreen === screen ? 'none' : `1px solid ${GREEN_COLORS.primary}`,
                                                                                        boxShadow: selectedScreen === screen ? `0 2px 8px ${GREEN_COLORS.shadow}` : 'none',
                                                                                        outline: 'none'
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        if (selectedScreen !== screen) {
                                                                                            e.target.style.backgroundColor = GREEN_COLORS.light;
                                                                                            e.target.style.borderColor = GREEN_COLORS.primary;
                                                                                        }
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        if (selectedScreen !== screen) {
                                                                                            e.target.style.backgroundColor = 'transparent';
                                                                                            e.target.style.borderColor = GREEN_COLORS.primary;
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {screen}
                                                                                </button>
                                                                            ))}
                                                                        </div>
                                                                    ) : isVideoPlayer ? (
                                                                        selectedScreen ? (
                                                                            <div style={{
                                                                                backgroundColor: '#f8f9fa',
                                                                                borderRadius: '8px',
                                                                                padding: '15px',
                                                                                border: '2px dashed #dee2e6'
                                                                            }}>
                                                                                {selectedAdFormat === "video" || selectedAdFormat === "combined" ? (
                                                                                    <video
                                                                                        width="100%"
                                                                                        controls
                                                                                        autoPlay
                                                                                        style={{ maxHeight: '300px' }}
                                                                                        key={r.value}
                                                                                    >
                                                                                        <source src={r.value} type="video/mp4" />
                                                                                        Your browser does not support the video tag.
                                                                                    </video>
                                                                                ) : selectedAdFormat === "image" ? (
                                                                                    <div className="text-center">
                                                                                        <img
                                                                                            src={rows.find(row => row.key === "Image Content")?.images?.[0]?.url ||
                                                                                                rows.find(row => row.key === "Image Content")?.value}
                                                                                            alt="Advertisement"
                                                                                            style={{
                                                                                                maxWidth: '100%',
                                                                                                maxHeight: '300px',
                                                                                                objectFit: 'contain'
                                                                                            }}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Available';
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                ) : selectedAdFormat === "text" ? (
                                                                                    <div style={{
                                                                                        padding: '20px',
                                                                                        backgroundColor: 'white',
                                                                                        borderRadius: '4px',
                                                                                        border: '1px solid #dee2e6',
                                                                                        minHeight: '200px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}>
                                                                                        <p style={{ fontSize: '18px', color: '#333' }}>
                                                                                            {rows.find(row => row.key === "Text Content")?.value || "No text content available"}
                                                                                        </p>
                                                                                    </div>
                                                                                ) : null}

                                                                                {/* Tabs for combined format */}
                                                                                {selectedAdFormat === "combined" && (
                                                                                    <div className="mt-3">
                                                                                        <div className="nav nav-tabs mb-3">
                                                                                            <button
                                                                                                className={`nav-link ${activeContentType === 'video' ? 'active' : ''}`}
                                                                                                onClick={() => setActiveContentType('video')}
                                                                                                style={{
                                                                                                    padding: '8px 16px',
                                                                                                    border: 'none',
                                                                                                    backgroundColor: activeContentType === 'video' ? GREEN_COLORS.primary : 'transparent',
                                                                                                    color: activeContentType === 'video' ? 'white' : '#555',
                                                                                                    borderRadius: '4px',
                                                                                                    marginRight: '5px',
                                                                                                    cursor: 'pointer'
                                                                                                }}
                                                                                            >
                                                                                                Video
                                                                                            </button>
                                                                                            <button
                                                                                                className={`nav-link ${activeContentType === 'image' ? 'active' : ''}`}
                                                                                                onClick={() => setActiveContentType('image')}
                                                                                                style={{
                                                                                                    padding: '8px 16px',
                                                                                                    border: 'none',
                                                                                                    backgroundColor: activeContentType === 'image' ? GREEN_COLORS.primary : 'transparent',
                                                                                                    color: activeContentType === 'image' ? 'white' : '#555',
                                                                                                    borderRadius: '4px',
                                                                                                    marginRight: '5px',
                                                                                                    cursor: 'pointer'
                                                                                                }}
                                                                                            >
                                                                                                Image
                                                                                            </button>
                                                                                            <button
                                                                                                className={`nav-link ${activeContentType === 'text' ? 'active' : ''}`}
                                                                                                onClick={() => setActiveContentType('text')}
                                                                                                style={{
                                                                                                    padding: '8px 16px',
                                                                                                    border: 'none',
                                                                                                    backgroundColor: activeContentType === 'text' ? GREEN_COLORS.primary : 'transparent',
                                                                                                    color: activeContentType === 'text' ? 'white' : '#555',
                                                                                                    borderRadius: '4px',
                                                                                                    cursor: 'pointer'
                                                                                                }}
                                                                                            >
                                                                                                Text
                                                                                            </button>
                                                                                        </div>

                                                                                        {activeContentType === 'video' && (
                                                                                            <video
                                                                                                width="100%"
                                                                                                controls
                                                                                                style={{ maxHeight: '300px' }}
                                                                                            >
                                                                                                <source src={r.value} type="video/mp4" />
                                                                                                Your browser does not support the video tag.
                                                                                            </video>
                                                                                        )}
                                                                                        {activeContentType === 'image' && (
                                                                                            <div className="text-center">
                                                                                                <img
                                                                                                    src={rows.find(row => row.key === "Image Content")?.images?.[0]?.url ||
                                                                                                        rows.find(row => row.key === "Image Content")?.value}
                                                                                                    alt="Advertisement"
                                                                                                    style={{
                                                                                                        maxWidth: '100%',
                                                                                                        maxHeight: '300px',
                                                                                                        objectFit: 'contain'
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        {activeContentType === 'text' && (
                                                                                            <div style={{
                                                                                                padding: '20px',
                                                                                                backgroundColor: 'white',
                                                                                                borderRadius: '4px',
                                                                                                border: '1px solid #dee2e6',
                                                                                                minHeight: '200px'
                                                                                            }}>
                                                                                                <p style={{ fontSize: '16px', color: '#333' }}>
                                                                                                    {rows.find(row => row.key === "Text Content")?.value || "No text content available"}
                                                                                                </p>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}

                                                                                <p className="mt-2 text-muted">
                                                                                    Playing: {rows.find(row => row.key === "Restaurant Name")?.value} - {selectedScreen}
                                                                                    {selectedAdFormat !== "combined" && ` (${selectedAdFormat} mode)`}
                                                                                </p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="p-3">
                                                                                <p className="text-muted mb-0">Please select a screen above to view content</p>
                                                                            </div>
                                                                        )
                                                                    ) : isImageContent ? (
                                                                        <div>
                                                                            {isEditing && isEditableField ? (
                                                                                <input
                                                                                    type="file"
                                                                                    accept="image/*"
                                                                                    onChange={(e) => {
                                                                                        const file = e.target.files[0];
                                                                                        if (file) {
                                                                                            const newImages = [{
                                                                                                url: URL.createObjectURL(file),
                                                                                                file
                                                                                            }];
                                                                                            setRows(prev =>
                                                                                                prev.map((row, idx) =>
                                                                                                    idx === i
                                                                                                        ? {
                                                                                                            ...row,
                                                                                                            images: newImages
                                                                                                        }
                                                                                                        : row
                                                                                                )
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    className="form-control mb-2"
                                                                                />
                                                                            ) : null}
                                                                            {r.images && r.images.length > 0 ? (
                                                                                <ImageDisplay images={r.images} fieldName={r.key} />
                                                                            ) : (
                                                                                <span>No image uploaded</span>
                                                                            )}
                                                                        </div>
                                                                    ) : isTextContent ? (
                                                                        isEditing && isEditableField ? (
                                                                            <textarea
                                                                                value={r.value || ""}
                                                                                onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                className="form-control"
                                                                                rows="3"
                                                                                style={{ width: '100%' }}
                                                                            />
                                                                        ) : (
                                                                            <div style={{
                                                                                padding: '10px',
                                                                                backgroundColor: '#f8f9fa',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #dee2e6'
                                                                            }}>
                                                                                {r.value || "N/A"}
                                                                            </div>
                                                                        )
                                                                    ) : isAdFormat ? (
                                                                        isEditing && isEditableField ? (
                                                                            <div className="d-flex flex-wrap gap-2">
                                                                                {adFormatOptions.map((option) => (
                                                                                    <button
                                                                                        key={option.value}
                                                                                        className="btn"
                                                                                        onClick={() => handleAdFormatSelect(option.value)}
                                                                                        style={{
                                                                                            padding: '8px 16px',
                                                                                            fontSize: '13px',
                                                                                            fontWeight: '600',
                                                                                            borderRadius: '8px',
                                                                                            cursor: 'pointer',
                                                                                            transition: 'all 0.3s ease',
                                                                                            backgroundColor: selectedAdFormat === option.value ? GREEN_COLORS.primary : 'transparent',
                                                                                            color: selectedAdFormat === option.value ? 'white' : GREEN_COLORS.primary,
                                                                                            border: selectedAdFormat === option.value ? 'none' : `1px solid ${GREEN_COLORS.primary}`,
                                                                                            boxShadow: selectedAdFormat === option.value ? `0 4px 12px ${GREEN_COLORS.shadow}` : 'none',
                                                                                            outline: 'none',
                                                                                            minWidth: '120px'
                                                                                        }}
                                                                                        onMouseEnter={(e) => {
                                                                                            if (selectedAdFormat !== option.value) {
                                                                                                e.target.style.backgroundColor = GREEN_COLORS.light;
                                                                                                e.target.style.borderColor = GREEN_COLORS.primary;
                                                                                            }
                                                                                        }}
                                                                                        onMouseLeave={(e) => {
                                                                                            if (selectedAdFormat !== option.value) {
                                                                                                e.target.style.backgroundColor = 'transparent';
                                                                                                e.target.style.borderColor = GREEN_COLORS.primary;
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {option.label}
                                                                                    </button>
                                                                                ))}
                                                                            </div>
                                                                        ) : (
                                                                            <span style={{
                                                                                backgroundColor: GREEN_COLORS.primary,
                                                                                color: 'white',
                                                                                padding: '6px 12px',
                                                                                borderRadius: '6px',
                                                                                fontSize: '12px',
                                                                                fontWeight: '600',
                                                                                display: 'inline-block',
                                                                                boxShadow: `0 2px 4px ${GREEN_COLORS.shadow}`
                                                                            }}>
                                                                                {adFormatOptions.find(opt => opt.value === r.value)?.label || r.value}
                                                                            </span>
                                                                        )
                                                                    ) : r.key === "Video Duration" ? (
                                                                        isEditing && isEditableField ? (
                                                                            <select
                                                                                value={r.value || ""}
                                                                                onChange={(e) => handleDurationChange(e.target.value)}
                                                                                className="form-select w-75"
                                                                            >
                                                                                <option value="">Select Duration</option>
                                                                                {durationOptions.map((option) => (
                                                                                    <option key={option} value={option}>
                                                                                        {option}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            r.value || "N/A"
                                                                        )
                                                                    ) : r.key === "Video Time" ? (
                                                                        isEditing && isEditableField ? (
                                                                            <select
                                                                                value={r.value || ""}
                                                                                onChange={(e) => handleVideoTimeChange(e.target.value)}
                                                                                className="form-select w-75"
                                                                            >
                                                                                <option value="">Select Time</option>
                                                                                {timeOptions.map((option) => (
                                                                                    <option key={option} value={option}>
                                                                                        {option}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            r.value || "N/A"
                                                                        )
                                                                    ) : r.key === "Start Date" || r.key === "End Date" || r.key === "Upload Date" || r.key === "Owner Date of Birth" ? (
                                                                        isEditing && isEditableField ? (
                                                                            <input
                                                                                type="date"
                                                                                value={safeDateToISOString(r.value)}
                                                                                onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                className="form-control d-inline-block w-75"
                                                                            />
                                                                        ) : (
                                                                            safeDateDisplay(r.value)
                                                                        )
                                                                    ) : r.key === "Description" ? (
                                                                        isEditing && isEditableField ? (
                                                                            <textarea
                                                                                value={r.value || ""}
                                                                                onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                className="form-control d-inline-block w-75"
                                                                                rows="3"
                                                                            />
                                                                        ) : (
                                                                            r.value || "N/A"
                                                                        )
                                                                    ) : r.key === "Company Name" ||
                                                                        r.key === "Owner Name" ||
                                                                        r.key === "Owner Full Name" ||
                                                                        r.key === "Restaurant Name" ||
                                                                        r.key === "Vendor ID" ? (
                                                                        <div>
                                                                            {isEditing && isEditableField ? (
                                                                                <input
                                                                                    type="text"
                                                                                    value={r.value || ""}
                                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                    className="form-control d-inline-block w-75 mb-2"
                                                                                />
                                                                            ) : (
                                                                                r.value || "N/A"
                                                                            )}
                                                                        </div>
                                                                    ) : r.key === "Business Type" ||
                                                                        r.key === "Company PAN" ||
                                                                        r.key === "Company GST" ||
                                                                        r.key === "CIN" ||
                                                                        r.key === "Registered Address" ||
                                                                        r.key === "City" ||
                                                                        r.key === "State" ||
                                                                        r.key === "Pincode" ||
                                                                        r.key === "Owner PAN" ||
                                                                        r.key === "Owner Aadhaar" ||
                                                                        r.key === "Owner Mobile" ||
                                                                        r.key === "Owner Email" ||
                                                                        r.key === "Owner Address" ? (
                                                                        isEditing && isEditableField ? (
                                                                            <input
                                                                                type="text"
                                                                                value={r.value || ""}
                                                                                onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                className="form-control d-inline-block w-75"
                                                                            />
                                                                        ) : (
                                                                            r.value || "N/A"
                                                                        )
                                                                    ) : r.key === "Company PAN Document" ? (
                                                                        "Company PAN Document"
                                                                    ) : r.key === "Incorporation Certificate" ? (
                                                                        "Incorporation Certificate"
                                                                    ) : r.key === "GST Certificate" ? (
                                                                        "GST Certificate"
                                                                    ) : r.key === "Trade License" ? (
                                                                        "Trade License"
                                                                    ) : r.key === "Owner PAN Document" ? (
                                                                        "Owner PAN Document"
                                                                    ) : r.key === "Owner Aadhaar Document" ? (
                                                                        "Owner Aadhaar Document"
                                                                    ) : r.key === "Owner Image" ? (
                                                                        "Owner Image"
                                                                    ) : (
                                                                        r.value || "N/A"
                                                                    )}
                                                                </td>

                                                                <td className="text-center align-middle">
                                                                    {isEditing && isEditableField ? (
                                                                        <>
                                                                            {(r.key === "Company PAN Document" ||
                                                                                r.key === "Incorporation Certificate" ||
                                                                                r.key === "GST Certificate" ||
                                                                                r.key === "Trade License" ||
                                                                                r.key === "Owner PAN Document" ||
                                                                                r.key === "Owner Aadhaar Document" ||
                                                                                r.key === "Owner Image" ||
                                                                                r.key === "Image Content") && (
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple={r.key !== "Image Content" && r.key !== "Owner Image"}
                                                                                        accept="image/*"
                                                                                        onChange={handleImageChange}
                                                                                        className="form-control mb-2"
                                                                                    />
                                                                                )}
                                                                            <ImageDisplay images={r.images} fieldName={r.key} />
                                                                        </>
                                                                    ) : (
                                                                        <ImageDisplay images={r.images} fieldName={r.key} />
                                                                    )}
                                                                </td>

                                                                <td className="text-center align-middle">
                                                                    {isEditing && isEditableField ? (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-success me-2"
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() => handleSaveRow(i)}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-secondary"
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() =>
                                                                                    setRows((prev) =>
                                                                                        prev.map((row, idx) =>
                                                                                            idx === i ? { ...row, isEditing: false } : row
                                                                                        )
                                                                                    )
                                                                                }
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <div style={{ display: "flex", gap: "10px" }}>
                                                                            {isFieldVerified(r.key, r.value, videoDetails, r.images) ? (
                                                                                <button
                                                                                    className="btn btn-sm btn-success"
                                                                                    style={{ minWidth: 80 }}
                                                                                    disabled
                                                                                >
                                                                                    Verified ✓
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-sm btn-warning"
                                                                                    style={{ minWidth: 80 }}
                                                                                    onClick={() => handleVerify(i)}
                                                                                    disabled={!canVerifyField(r.key, r.value, videoDetails, r.images) || !isEditableField}
                                                                                >
                                                                                    Verify
                                                                                </button>
                                                                            )}

                                                                            {isFieldRejected(r.key, videoDetails) ? (
                                                                                <button
                                                                                    className="btn btn-sm btn-danger"
                                                                                    style={{ minWidth: 80 }}
                                                                                    disabled
                                                                                >
                                                                                    Rejected ✗
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-sm btn-secondary"
                                                                                    style={{ minWidth: 80 }}
                                                                                    onClick={() => handleReject(i)}
                                                                                    disabled={
                                                                                        !hasValidData({ key: r.key, value: r.value, images: r.images }, videoDetails) ||
                                                                                        !isEditableField
                                                                                    }
                                                                                >
                                                                                    Reject
                                                                                </button>
                                                                            )}

                                                                            {/* Edit button - only show for editable fields */}
                                                                            {isEditableField && (
                                                                                <button
                                                                                    className="btn btn-sm btn-primary"
                                                                                    style={{ minWidth: 80 }}
                                                                                    onClick={() =>
                                                                                        setRows((prev) =>
                                                                                            prev.map((row, idx) =>
                                                                                                idx === i ? { ...row, isEditing: true } : row
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}

                                {/* Global Approve/Reject Buttons at Bottom */}
                                {!loading && !videoNotFound && videoDetails && (
                                    <div className="d-flex justify-content-center gap-3 mt-4 mb-4 p-3 border-top">
                                        <div className="d-flex gap-3 align-items-start">
                                            {/* Approve Button */}
                                            <button
                                                className="btn btn-success px-4 py-2 fw-bold"
                                                style={{ minWidth: "120px", fontSize: "16px" }}
                                                onClick={handleGlobalApprove}
                                                disabled={isApproving || isRejecting}
                                            >
                                                {isApproving ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                                        Approving...
                                                    </>
                                                ) : (
                                                    "Approve All"
                                                )}
                                            </button>

                                            {/* Reject Button with Dropdown */}
                                            <div className="position-relative">
                                                {showRejectDropdown ? (
                                                    <div className="card p-3 shadow-sm" style={{
                                                        width: "350px",
                                                        position: "absolute",
                                                        top: "100%",
                                                        left: "0",
                                                        marginTop: "10px",
                                                        zIndex: 1000
                                                    }}>
                                                        <div className="mb-3">
                                                            <label className="form-label fw-bold">Rejection Reason</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows="4"
                                                                placeholder="Enter rejection reason for all fields..."
                                                                value={rejectionReason}
                                                                onChange={(e) => setRejectionReason(e.target.value)}
                                                                disabled={isApproving || isRejecting}
                                                            />
                                                        </div>

                                                        <div className="d-flex gap-2">
                                                            <button
                                                                className="btn btn-danger flex-grow-1"
                                                                onClick={handleGlobalReject}
                                                                disabled={!rejectionReason.trim() || isApproving || isRejecting}
                                                            >
                                                                {isRejecting ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                                                        Rejecting...
                                                                    </>
                                                                ) : (
                                                                    "Confirm Reject All"
                                                                )}
                                                            </button>
                                                            <button
                                                                className="btn btn-secondary"
                                                                onClick={() => {
                                                                    setShowRejectDropdown(false);
                                                                    setRejectionReason("");
                                                                }}
                                                                disabled={isApproving || isRejecting}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <button
                                                        className="btn btn-danger px-4 py-2 fw-bold"
                                                        style={{ minWidth: "120px", fontSize: "16px" }}
                                                        onClick={() => setShowRejectDropdown(true)}
                                                        disabled={isApproving || isRejecting}
                                                    >
                                                        {isRejecting ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                                Rejecting...
                                                            </>
                                                        ) : (
                                                            "Reject All"
                                                        )}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper function for status badge
const getStatusBadge = (status) => {
    switch (status) {
        case 'verified':
            return {
                backgroundColor: '#4CAF50',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: '500',
                display: 'inline-block'
            };
        case 'pending':
            return {
                backgroundColor: '#FFC107',
                color: '#333',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: '500',
                display: 'inline-block'
            };
        case 'rejected':
            return {
                backgroundColor: '#f44336',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: '500',
                display: 'inline-block'
            };
        default:
            return {
                backgroundColor: '#9E9E9E',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: '500',
                display: 'inline-block'
            };
    }
};

// Helper function for ad format badge
const getAdFormatBadge = (format) => {
    const styles = {
        video: {
            backgroundColor: '#2196F3',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            display: 'inline-block'
        },
        image: {
            backgroundColor: '#FF9800',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            display: 'inline-block'
        },
        text: {
            backgroundColor: '#9C27B0',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            display: 'inline-block'
        },
        combined: {
            backgroundColor: '#E91E63',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            display: 'inline-block'
        }
    };

    return styles[format] || styles.video;
};

const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
const thTdStyle = { border: "1px solid #ddd", textAlign: "center", padding: "8px", verticalAlign: "middle" };
const thStyle = { ...thTdStyle, backgroundColor: "#b15cd6", color: "#fff", fontWeight: "bold", whiteSpace: "nowrap" };
const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

const detailThStyle = {
    ...thTdStyle,
    backgroundColor: "#b15cd6",
    color: "#fff",
    fontWeight: 600,
    padding: "0.75rem",
    verticalAlign: "middle",
    border: "1px solid #dee2e6",
    textAlign: "center"
};

export default FoodVideosSuperadmin;